<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="16px" style="margin-bottom: 24px">
  <h2 class="nomargin">Set your markup rate</h2>
  <p>
    When updating prices from the {{ 'CORE.PRODUCT_NAME' | transloco }} calendar the platform markup will be
    automatically added to the price.
  </p>
</div>

<div class="markup-container" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
  <div fxFlex fxLayout="column">
    <div fxLayout fxLayoutAlign="start center">
      <strong>{{ platform | platformLabel }}</strong>
    </div>
    <div class="night-lighter text__small">Your {{ platform | platformLabel }} markup rate</div>
  </div>
  <mat-form-field>
    <input matInput [(ngModel)]="markup" type="tel" maxlength="6" [placeholder]="placeholder_markup" />
    <span matSuffix>%</span>
  </mat-form-field>
</div>

<div style="margin-top: 24px" fxLayoutGap="4px" fxLayoutAlign="start center" *ngIf="platform !== 'booking'">
  <svg fxHide.lt-md width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.22779 11H8.75274C8.50076 11 8.2591 10.8946 8.08092 10.7071C7.90274 10.5196 7.80264 10.2652 7.80264 10V7.5C7.80264 7.36739 7.75259 7.24022 7.6635 7.14645C7.57441 7.05268 7.45358 7 7.32759 7H6.85254"
      stroke="#B3AFBB"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.56516 4.5C7.51818 4.5 7.47226 4.51466 7.4332 4.54213C7.39414 4.5696 7.36369 4.60865 7.34572 4.65433C7.32774 4.70001 7.32304 4.75028 7.3322 4.79877C7.34137 4.84727 7.36399 4.89181 7.39721 4.92678C7.43042 4.96174 7.47275 4.98555 7.51882 4.9952C7.5649 5.00484 7.61266 4.99989 7.65606 4.98097C7.69946 4.96205 7.73656 4.93 7.76266 4.88889C7.78876 4.84778 7.80269 4.79945 7.80269 4.75C7.80269 4.6837 7.77766 4.62011 7.73312 4.57322C7.68857 4.52634 7.62816 4.5 7.56516 4.5Z"
      stroke="#B3AFBB"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.80251 15.5C11.738 15.5 14.9283 12.1421 14.9283 8C14.9283 3.85786 11.738 0.5 7.80251 0.5C3.86706 0.5 0.676758 3.85786 0.676758 8C0.676758 12.1421 3.86706 15.5 7.80251 15.5Z"
      stroke="#B3AFBB"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>

  <span>You can override this markup rate on a per-listing basis from the Properties page.</span>
</div>

<div style="margin-top: 24px" fxLayoutGap="4px" fxLayoutAlign="start start" *ngIf="platform === 'booking'">
  <ul>
    <li style="margin-bottom: 10px">Setting a Markup is required to push rates</li>
    <li style="margin-bottom: 10px">
      If we pull in your BDC rates when your markup is greater than 0, your rates in Hospitable.com will be lower
    </li>
    <li style="margin-bottom: 10px">
      You can override this markup rate on a per-listing basis from the Properties page
    </li>
  </ul>
</div>

<p class="grass-darker" *ngIf="platform === 'booking'">
  <a href="https://my.hospitable.com/support-documentation/article/4618764-what-are-markup-rates" target="_blank">
    How does Hospitable.com calculate markups?
  </a>
</p>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="booking-com-set-markup-skip"
    label="Skip for now"
    type="secondary"
    (click)="skip()"
    *ngIf="platform !== 'booking'"></sbnb-button>
  <sbnb-button
    data-intercom-target="booking-com-set-markup-save"
    [disabled]="!markup"
    [loading]="saving"
    label="Continue"
    (click)="progress()"></sbnb-button>
</div>
